import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { T_D } from '../constants';
import type { TableCellElement, TDElement } from '../types';
import { isTableHeaderCell } from './isTableHeaderCell';

const isDataCell = isElementType<TDElement>(T_D);

/** Whether a node is a table cell, either a data cell (`td`) or a header cell (`th`). */
export const isTableCell = (node: any): node is TableCellElement => isDataCell(node) || isTableHeaderCell(node);
